module.exports = __webpack_public_path__ + "img/lk-mode-circle.eba24dd8.svg";